import { useQuery } from '@tanstack/react-query';
import { getFolders } from 'services/fileManager/fileManagerServices';
import { queryKeys } from 'hooks/config/queryClient';

export function useFoldersQuery(params = '', data = {}, enabled = true) {
  return useQuery({
    queryKey: queryKeys.fileManager.folders(params || '', data),
    queryFn: async () => {
      const response = await getFolders(params, data);
      return response?.data || [];
    },
    enabled: enabled && !!params,
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
